import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuidePartnerTagForm from '../containers/CareGuidePartnerTagFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuidePartnerTagEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuidePartnerTagEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_partner_tag_route_edit')} />
          <CareGuidePartnerTagForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuidePartnerTagEditScreen;

Logger.log('silly', `CareGuidePartnerTagEditScreen loaded.`);